import { render, staticRenderFns } from "./ShenzhenMobileElm39.vue?vue&type=template&id=6a83051f&scoped=true"
import script from "./ShenzhenMobileElm39.vue?vue&type=script&lang=js"
export * from "./ShenzhenMobileElm39.vue?vue&type=script&lang=js"
import style0 from "./ShenzhenMobileElm39.vue?vue&type=style&index=0&id=6a83051f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83051f",
  null
  
)

export default component.exports